import { TableViewStore, BaseListViewStore } from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { InsuranceService } from 'application/import-reference/services';
import { resolveColumns } from 'application/facility/util/resolveColumns';

@applicationContext
class InsuranceManagementListViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const service = new InsuranceService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'insurance-management',
            autoInit: true,
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            },
            routes: {
                edit: item => {
                    this.setChildNavigationTitle(i =>
                        i.id === item.id,
                        () => item.name
                    );
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.insurance-management.edit',
                        { id: item.id }
                    )
                },
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await service.find({
                            ...params,
                        });

                        return response.data;
                    }
                }
            }
        });

        this.sync = async () => {
            this.loaderStore.suspend();                            
            this.tableStore.suspend();    
            try{
                await service.sync();
                await this.queryUtility.fetch();
                this.rootStore.notificationStore.success("Sync successfully done.");                                       
            }catch(err){
                this.rootStore.notificationStore.error(err && err.data && err.data.errors ? err.data.errors : 'Error occurred while trying to sync insurances.');                                                       
            }        
            this.tableStore.resume();    
            this.loaderStore.resume();                                        
        };

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'name',
                    title: 'INSURANCE_MANAGEMENT.LIST.COLUMNS.NAME'
                },
                {
                    key: 'abbreviatedName',
                    title: 'INSURANCE_MANAGEMENT.LIST.COLUMNS.ABBREVIATED_NAME'
                },
                {
                    key: 'description',
                    title: 'INSURANCE_MANAGEMENT.LIST.COLUMNS.DESCRIPTION'
                },
            ]),
            actions: {
                onEdit: async (item) => this.routes.edit(item),
            }
        }));
    }
}

export default InsuranceManagementListViewStore;
